import { Files } from '@phosphor-icons/react';

export default Files;
